async function makeRequest(reqBody) {
    const tokenRes = await fetch(
        process.env.REACT_APP_LAMBDA_AUTH_ENDPOINT
    ).then((response) => response.json());
    let token = tokenRes.accessToken;

    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            Prefer: "return=representation",
        },
        body: JSON.stringify(reqBody),
    };
    const postRes = await fetch(
        process.env.REACT_APP_CRM_LEAD_ENDPOINT,
        requestOptions
    ).then((response) => response.json());
    if (postRes) {
        console.log("Success!", postRes);
    }
}

export default makeRequest;
